export enum IntegrationActionStatus {
  Success = 'SUCCESS',
  Failed = 'FAILED',
}
